import React from 'react';
import PropTypes from 'prop-types';
import css from './styles.less';

class Button extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            direction,
            isRounded,
            isShadow,
            onClickHandler,
            id,
            text,
            disable
        } = this.props;
        
        const wrapperClassName = `${css.buttonHolder} 
                                ${css[direction]} 
                                ${isRounded && css.rounded} 
                                ${isShadow && css.shadow}
                                ${disable && css.disabled}`;
        
        const btnClass = `${css.button} ${disable && css.disabled} sbox__submit`;
        return (<div className={wrapperClassName}
            onMouseLeave={this.mouseLeave} onMouseEnter={this.mouseEnter}>
            <button 
                onClick={!disable && onClickHandler}
                className={btnClass}
                type='button'
                id={id}
            >
                {text}
            </button>
        </div>
        );
    }
}

Button.propTypes = {
    onClickHandler: PropTypes.func,
    direction: PropTypes.oneOf(['left', 'right']),
    isRounded: PropTypes.bool,
    isShadow: PropTypes.bool,
    id: PropTypes.string,
    text: PropTypes.string,
    disable: PropTypes.bool
};

Button.defaultProps = {
    direction: 'left',
    isRounded: true,
    isShadow: true,
    text: 'Submit',
    disable: false
};

export default Button;


// WEBPACK FOOTER //
// ./src/components/Button/Button.js